import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

export type ExportItemFromFusionRequestBody = {
  partFileUuids: string[];
  hubId: string;
  projectId: string;
  folderId: string | null;
};

export type ExportItemFromFusionResponse = {
  taskUuid: string;
};

/**
 *
 * Mutation function for export part files from our API into ADSK fusion. Returns a task ID
 * that can be used to track the status of the export.
 */
export const useExportFileToFusion: MutationFunction<
  ExportItemFromFusionResponse,
  ExportItemFromFusionRequestBody
> = ({ requestOptions, queryOptions } = {}) => {
  const urlPath = '/integrations/fusion/export';
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: (body) => {
      return request(urlPath, {
        init: {
          method: 'POST',
          body,
        },
      });
    },
    ...queryOptions,
    mutationKey: ['exportItemToFusion'],
  });
};
